import { useEffect } from "react";

// Ancre de défilement : le 1er élément « carte » encore visible en haut de l'écran + son décalage.
// Sert à revenir PILE au même endroit après un aller-retour (publication, visionneuse, Reels…) alors que
// des blocs asynchrones (stories, directs, pubs) changent la hauteur au-dessus.
const DEFAULT_SELECTORS = "article.yalola-card[data-testid^='post-'], [data-testid^='profile-reel-']";

export const captureScrollAnchor = (selectors = DEFAULT_SELECTORS) => {
  for (const el of document.querySelectorAll(selectors)) {
    const r = el.getBoundingClientRect();
    if (r.bottom > 80) {
      const sel = `[data-testid="${el.dataset.testid}"]`;
      // Même testid possible à plusieurs endroits (vignette Reels dans le bandeau « populaires » ET la grille) → rang.
      const index = Array.prototype.indexOf.call(document.querySelectorAll(sel), el);
      return { sel, index: Math.max(0, index), top: r.top };
    }
  }
  return null;
};

const anchorEl = (anchor) => document.querySelectorAll(anchor.sel)[anchor.index || 0] || null;

// Ré-ancrage impératif (lot 682, partagé avec le hook) : premières frames (~2 s) puis à chaque changement de mise en
// page (ResizeObserver) pendant 8 s max — abandonné dès que le membre fait défiler lui-même. Renvoie une fonction d'arrêt.
export const startAnchorRestore = (anchor) => {
  if (!anchor?.sel || typeof window === "undefined") return () => {};
  let stop = false;
  const evs = ["wheel", "touchstart", "keydown", "pointerdown"];
  const fix = () => {
    if (stop) return;
    const el = anchorEl(anchor);
    if (!el) return;
    const drift = el.getBoundingClientRect().top - anchor.top;
    if (Math.abs(drift) > 2) window.scrollBy({ top: drift, behavior: "instant" });
  };
  let frames = 0;
  const tick = () => { if (stop) return; fix(); if (++frames < 120) requestAnimationFrame(tick); };
  tick();
  const ro = typeof ResizeObserver !== "undefined" ? new ResizeObserver(fix) : null;
  ro?.observe(document.body);
  const end = setTimeout(() => { stop = true; ro?.disconnect(); }, 8000);
  const cancel = () => { stop = true; ro?.disconnect(); clearTimeout(end); evs.forEach((e) => window.removeEventListener(e, cancel)); };
  evs.forEach((e) => window.addEventListener(e, cancel, { passive: true }));
  return cancel;
};

// Ré-ancrage au montage (retour sur le fil depuis une autre page : l'ancre vient de la mémoire de session).
export const useScrollAnchorRestore = (anchor) => {
  useEffect(() => startAnchorRestore(anchor),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
};
